export default __webpack_public_path__ + "static/media/CNo.61-1.68ed6b0c.jpg";